module.exports = __webpack_public_path__ + "static/formations-1b284e4f5d64a16887f93807bb10190e.svg";